module.exports = __webpack_public_path__ + "media/images/app/homepage/wot1-6432f8a5af9f5872d35f247801d28b00.webp";